module.exports = __webpack_public_path__ + "img/question-left.3be2c7b.png";